import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { isDefined, optionalKey } from '@grandvisionhq/utils';
import { getPriceSpecificationConfig } from '../../utils/get-price-specification-config.js';
import { parseListingProductData } from '../../utils/parse-listing-product-data.js';
import { createPriceSpecification } from '../actions/helpers.js';
import { JsonLd } from '../JsonLd.js';

const ProductsSd = ({ items , links , originUrl  })=>{
    const productList = items.map((product, index)=>{
        var ref;
        const sku = product.masterVariant.sku;
        const activeVariant = product.masterVariant;
        const link1 = (ref = links.find((link)=>link.sku === sku
        )) === null || ref === void 0 ? void 0 : ref.link;
        const productUrl = `${originUrl || ''}${link1}`;
        const { name , description , brand , category  } = parseListingProductData(product, activeVariant);
        const specification = isDefined(activeVariant.pricing.price) ? getPriceSpecificationConfig(activeVariant.pricing.price, product.includedVatAmount) : undefined;
        const offers = [
            {
                '@type': 'Offer',
                priceSpecification: createPriceSpecification(specification, activeVariant.sku)
            }, 
        ];
        const aggregateRating = product.ratingsSummary ? {
            '@type': 'AggregateRating',
            ratingValue: product.ratingsSummary.average,
            reviewCount: product.ratingsSummary.reviewCount
        } : {};
        const listItemContent = swcHelpers.objectSpread({
            '@type': 'Product',
            '@id': `${productUrl}#product`,
            name: name && String(name) || sku,
            url: productUrl
        }, optionalKey('description', description), optionalKey('brand', brand), optionalKey('category', category), optionalKey('offers', offers), optionalKey('aggregateRating', aggregateRating), {
            sku
        });
        return {
            '@type': 'ListItem',
            position: index + 1,
            item: listItemContent
        };
    });
    const payload = {
        '@type': 'ItemList',
        itemListElement: productList
    };
    return /*#__PURE__*/ React.createElement(JsonLd, swcHelpers.extends({}, payload));
};

export { ProductsSd };
//# sourceMappingURL=Products.sd.js.map
